import React, { useState } from "react";
import Modal from "react-modal";
import DashboardCard from "../../../../pages/home/common/DashboardCard";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertTo12HourFormat,
  getDayFromDate,
} from "../../../common-data/Converts";
import {
  CheckCircleIcon,
  CrossCircleIcon,
} from "../../../../images/icons/icons";

const StatCardDetails = ({ calStats }) => {
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    tableArray: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const iniClickValues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    tableArray: [],
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  function onCloseClickValues() {
    setClickValues(iniClickValues);
  }

  function onClickCard(_, name) {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardName: name,
      tableArray:
        name === "on_time_checkins"
          ? calStats?.onTimeData || []
          : name === "late_checkins"
          ? calStats?.lateCheckinData || []
          : name === "checkin_missed"
          ? calStats?.checkInMissedData || []
          : name === "leave_applied"
          ? calStats?.leaveAppliedData || []
          : name === "day_off"
          ? calStats?.dayOffData || []
          : [],
    }));
  }

  const tbColumns = [
    {
      dataField: "date",
      text: "date",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "checkin_time",
      text: "checkin time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.checkin_time ? convertTo12HourFormat(row.checkin_time) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkout_time",
      text: "checkout time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.checkout_time
              ? convertTo12HourFormat(row.checkout_time)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.status?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "shift_difference",
      text: "shift difference",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.shift_difference || "-"}</span>;
      },
    },
    {
      dataField: "shift_status",
      text: "shift status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.shift_status?.replace(/-/g, " ") || "-"}
          </span>
        );
      },
    },
  ];

  const tbColumns_checkinMissed = [
    {
      dataField: "date",
      text: "date",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "date",
      text: "day",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? getDayFromDate(row.date) : "-"}
          </span>
        );
      },
    },
  ];

  const tbColumns_leaveApplied = [
    {
      dataField: "date",
      text: "date",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth100">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "is_leave",
      text: "Leave",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_leave ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "leave_details",
      text: "Leave Details",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "leave_details",
                rowData: row,
                tableArray: row?.leave_details || [],
              }))
            }
          >
            view
          </span>
        );
      },
    },
  ];

  const leaveDetailsTbCols = [
    {
      dataField: "leave_date",
      text: "leave date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.leave_date ? convertStraight(row.leave_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "leave_date",
      text: "leave day",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.leave_date ? getDayFromDate(row.leave_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "approva_status",
      text: "approval status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.approva_status ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "description",
      text: "remarks",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "block",
              lineHeight: "25px",
              textTransform: "initial",
              fontWeight: "400",
              textAlign: "start",
            }}
          >
            {row?.description || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "checkin_missed" ||
            modValues.cardName === "leave_applied" ||
            modValues.cardName === "day_off"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${modValues.cardName?.replace(/_/g, " ")}`}
            onClose={onCloseModal}
          />

          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            <PaymentLinkTable
              tableData={modValues.tableArray}
              tableColumns={
                modValues.cardName === "checkin_missed" ||
                modValues.cardName === "day_off"
                  ? tbColumns_checkinMissed
                  : modValues.cardName === "leave_applied"
                  ? tbColumns_leaveApplied
                  : tbColumns
              }
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseClickValues}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/_/g, " ")}`}
            onClose={onCloseClickValues}
          />

          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
            <PaymentLinkTable
              tableData={clickValues.tableArray}
              tableColumns={leaveDetailsTbCols}
            />
          </div>
        </div>
      </Modal>

      <div className="cards-container cards-grid-container lead-cards grid-4">
        {calStats &&
          Object.entries(calStats)
            .filter(
              ([key]) =>
                ![
                  "checkInMissedData",
                  "lateCheckinData",
                  "onTimeData",
                  "leaveAppliedData",
                  "dayOffData",
                ].includes(key)
            )
            .map(([key, value]) => (
              <DashboardCard
                key={key}
                tagName={key}
                cardLabel={key.replace(/_/g, " ")}
                value={value || 0}
                isFromAttendanceReport={true}
                isCardClickable={key !== "total_checkins" ? true : false}
                onClickCard={onClickCard}
              />
            ))}
      </div>
    </>
  );
};

export default StatCardDetails;
